import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'fc-outlined-input',
  templateUrl: './fc-outlined-input.component.html',
  styleUrls: ['./fc-outlined-input.component.scss']
})
export class FcOutlinedInputComponent implements OnInit {
  @Input()
  public control: FormControl;

  @Input()
  public required: boolean;

  @Input()
  public label: string;

  @Input()
  public maxLength: number;

  @Output()
  public next: EventEmitter<void>;

  @Input()
  public isPassword: boolean;

  @Input()
  public isNumber: boolean;

  @Input()
  public hideErrorTextEllipses = false;

  @Input()
  public prefixIcon = null;

  public inputType: 'number' | 'text' | 'password';

  constructor() {
    this.next = new EventEmitter<void>();
  }

  public ngOnInit(): void {
    if (this.isNumber) {
      this.inputType = 'number';
      return;
    }

    if (this.isPassword) {
      this.inputType = 'password';
      return;
    }

    this.inputType = 'text';
  }

  public changePasswordInputType(): void {
    this.inputType = this.inputType === 'text'
      ? 'password'
      : 'text';
  }
}
